var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoAddress = function SvgIconNoAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    x: 0.5,
    y: 0.5,
    fill: "#EAE6E1",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A67D44",
    d: "M33.063 92.5V61.388l20.74-15.556 20.742 15.556V92.5H58.99V74.352H48.62V92.5zM74.809 41.633h2.918v-7.296H74.81zm1.459 5.837q.62 0 1.04-.42t.42-1.04-.42-1.039-1.04-.42-1.04.42-.42 1.04.42 1.04 1.04.42m0 10.215q-5.874-4.998-8.774-9.285-2.9-4.286-2.9-7.934 0-5.472 3.52-8.72 3.52-3.246 8.154-3.246t8.153 3.247q3.52 3.246 3.521 8.719 0 3.648-2.9 7.934-2.9 4.287-8.774 9.285"
  })));
};
export default SvgIconNoAddress;